// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clusters{padding:3rem}.clusters__section p{margin-bottom:0;margin-left:8px}.clusters__section:not(:last-child){margin-bottom:32px}.clusters__section.change-clusters .number-input{width:40px;margin:0 4px}.clusters__section .darwin-button{margin-top:0 !important}\n", ""]);
// Exports
module.exports = exports;
